import React from "react";
import values from "lodash/values";
import groupBy from "lodash/groupBy";
import List from "../list/list.jsx";
import TicketListItem from "./ticket-list-item.jsx";

class TicketList extends React.Component {
  render() {
    // grouped by event
    let items = values(groupBy(this.props.tickets, t => t.event.id)).map(
      tickets => {
        return {
          event: tickets[0].event,
          tickets: tickets
        };
      }
    );

    return (
      <List
        items={items}
        timeGetter={i => i.event.start_time}
        endTimeGetter={i => i.event.end_time}
        ListItem={TicketListItem}
        hideDateHeaders={this.props.hideDateHeaders}
        hideActions={this.props.hideActions}
        showDividers={this.props.showDividers}
      />
    );
  }
}

export default TicketList;



// WEBPACK FOOTER //
// ./src/app/components/partials/ticket-list/ticket-list.jsx